import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ActionCreatorWithOptionalPayload } from '@reduxjs/toolkit';
import { IAppReduxStore } from '../../../../redux/store';
import { getStructureItemInfo } from '../../../../util/StructureUtils';
import { setCategoryChecked, setPackageChecked } from '../../../../redux/import/sliceImportDialog';
import CurrentStepLabel from './_parts/CurrentStepLabel';
import CheckboxTree from '../_parts/CheckboxTree';
import { StructureViewMode } from '../../../../types';

const mapper: Record<
    'Category' | 'Package',
    {
        checkedNodes: 'checkedCategories' | 'checkedPackages';
        onCheckCallback?: ActionCreatorWithOptionalPayload<[string, boolean], string>;
    }
> = {
    Category: {
        checkedNodes: 'checkedCategories',
        onCheckCallback: setCategoryChecked,
    },
    Package: {
        checkedNodes: 'checkedPackages',
        onCheckCallback: setPackageChecked,
    },
};

export default ({ mode }: { mode: StructureViewMode }) => {
    const dispatch = useDispatch();
    const structure = useSelector(
        (_store: IAppReduxStore) => _store.importViewData.viewStructures.data[mode],
    );
    const checkedNodes = useSelector(
        (_store: IAppReduxStore) => _store.importDialog[mapper[mode].checkedNodes],
    );

    const items = useMemo(
        () =>
            structure.map(item => {
                const info = getStructureItemInfo(structure, item);
                return {
                    ...info,
                    label: info.name,
                    parent: info.parent?.Subject,
                };
            }),
        [structure],
    );

    return (
        <>
            <CurrentStepLabel />
            <CheckboxTree
                withSearch
                items={items}
                checkedNodes={checkedNodes}
                onCheckNode={(id: string, isChecked: boolean) => {
                    dispatch(mapper[mode].onCheckCallback([id, isChecked]));
                }}
                withStructureIcons={mode}
            />
        </>
    );
};
